import EVENT from '../enums/event.js';
import dispatchEvent from '../utils/dispatch-event.js';

class Underlay extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      // eslint-disable-next-line no-underscore-dangle
      const _this = this;

      this.addEventListener('click', () => {
        dispatchEvent(EVENT.UNDERLAY.CLICKED, document);
      });

      [EVENT.FILTERS.FILTER_LIST_OPENED].forEach(event => {
        document.addEventListener(event, () => _this.display());
      });

      [EVENT.FILTERS.FILTER_LIST_CLOSED].forEach(event => {
        document.addEventListener(event, () => _this.hide());
      });
    });
  }

  display() {
    this.classList.remove('hidden');
  }

  hide() {
    this.classList.add('hidden');
  }
}

customElements.define('underlay-element', Underlay);
